module.exports = __webpack_public_path__ + "img/service1-00.cd1e7049.png";